// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3F1i3","filesListContainer":"PosDisputesFiles_filesListContainer__3oSNa","filesButton":"PosDisputesFiles_filesButton__36BPF"};